// External Dependencies
import { useTheme } from 'styled-components';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import { ListAdminOrganizationsResponseItem } from '@presto-assistant/api_types/api/admin/organizations';

// Internal Dependencies
import OrganizationList from './OrganizationList';

interface DrawerProps {
  expandedDistricts: Set<string>;
  handleCloseDrawer: () => void;
  handleToggleDistrict: (districtLabel: string) => void;
  organizations: ListAdminOrganizationsResponseItem[];
  selectedFips: { fips: string; name: string; } | null;
}

// Component Definition
const HeatMapDrawer = ({
  expandedDistricts,
  handleCloseDrawer,
  handleToggleDistrict,
  organizations,
  selectedFips,
}: DrawerProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      onClose={handleCloseDrawer}
      open={!!selectedFips}
      sx={{
        zIndex: theme.zIndex.drawer + 2, // Our NavBar is theme.zIndex.drawer + 1 🤷‍♂️
      }}
    >
      <Box
        sx={{
          padding: 2,
        }}
      >
        <Box
          alignItems="center"
          display="flex"
          sx={{
            marginBottom: 2,
          }}
        >
          <Typography variant="h6">
            Organizations in {selectedFips?.name || 'Selected'} County
          </Typography>
        </Box>

        <OrganizationList
          expandedDistricts={expandedDistricts}
          handleToggleDistrict={handleToggleDistrict}
          organizations={organizations}
        />
      </Box>
    </Drawer>
  );
};

export default HeatMapDrawer;
